import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as ReactJSSThemeProvider } from 'react-jss';
import { getClientEnvironmentDetails } from '@sm/utils';
import { WrenchTheme } from '@wds/styles';

const GlobalThemeProvider = ({ children }) => {
  const { isBrowser } = getClientEnvironmentDetails();
  useEffect(() => {
    /**
     *  remove the JSS styles from the DOM after the client has loaded
     *  https://cssinjs.org/react-jss?v=v10.4.0#server-side-rendering
     */
    if (isBrowser) {
      const jss = document.getElementById('jss');
      if (jss) {
        jss.remove();
      }
    }
  }, [isBrowser]);

  return (
    <ReactJSSThemeProvider theme={WrenchTheme}>
      {children}
    </ReactJSSThemeProvider>
  );
};

GlobalThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalThemeProvider;
